// extracted by mini-css-extract-plugin
export default {"trending":"atricles_trending__7YhpH","content":"atricles_content__Evy4P"};